/**
 * DashboardPage — tier router. Dispatches to FreeTier / Paid / Enterprise
 * dashboards based on the org's subscription_tier. Also renders the shared
 * TopBar chrome and the first-login WelcomeOverlay for paid tiers.
 */
import { useEffect, useState } from 'react';
import { TopBar } from '../layout/TopBar.jsx';
import { FreeTierDashboard } from './FreeTierDashboard.jsx';
import { PaidDashboard } from './PaidDashboard.jsx';
import { EnterpriseDashboard } from './EnterpriseDashboard.jsx';
import { WelcomeOverlay } from '../components/WelcomeOverlay.jsx';

function welcomeKey(userId) {
  return `cw:welcomeSeen:${userId}`;
}

export function DashboardPage({ user, organization, onLogout, navigate }) {
  const tier = organization?.subscription_tier || 'free';
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    if (!user?.id || tier === 'free') return;
    try {
      if (!localStorage.getItem(welcomeKey(user.id))) setShowWelcome(true);
    } catch { /* storage unavailable */ }
  }, [user?.id, tier]);

  const dismiss = () => {
    setShowWelcome(false);
    try { localStorage.setItem(welcomeKey(user.id), '1'); } catch { /* noop */ }
  };

  let body;
  if (tier === 'enterprise') {
    body = <EnterpriseDashboard user={user} organization={organization} navigate={navigate} />;
  } else if (tier === 'starter' || tier === 'pro') {
    body = <PaidDashboard user={user} organization={organization} navigate={navigate} />;
  } else {
    body = <FreeTierDashboard user={user} organization={organization} navigate={navigate} />;
  }

  return (
    <div className="app-frame">
      <TopBar
        projectName={null}
        reportId={null}
        user={user}
        organization={organization}
        onLogout={onLogout}
        navigate={navigate}
      />
      {body}
      {showWelcome && (
        <WelcomeOverlay user={user} organization={organization} onDismiss={dismiss} />
      )}
    </div>
  );
}
